import { Library, Sparkles } from "lucide-react";

const DIFFS = ["easy", "normal", "hard"];
const DIFF_LABEL = { easy: "Easy", normal: "Normal", hard: "Hard" };

export default function StatsPanel({ stats }) {
  return (
    <section className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4 mb-10">
      <StatCard
        label="Total"
        value={stats ? stats.total : "—"}
        accent
        icon={<Library className="w-3.5 h-3.5" />}
        testid="stat-total"
      />
      {DIFFS.map((d) => (
        <StatCard
          key={d}
          label={DIFF_LABEL[d]}
          value={stats ? stats.by_difficulty[d] : "—"}
          testid={`stat-${d}`}
        />
      ))}
      <StatCard
        label="AI-sourced"
        value={stats ? (stats.by_source.claude || 0) + (stats.by_source.openai || 0) : "—"}
        icon={<Sparkles className="w-3.5 h-3.5" />}
        testid="stat-claude"
      />
    </section>
  );
}

function StatCard({ label, value, icon, accent, testid }) {
  return (
    <div
      className={`border-2 border-[#1A1A1A] px-4 py-3 ${
        accent
          ? "bg-[#1A1A1A] text-[#F4F1EA] shadow-[3px_3px_0px_#EB5E28]"
          : "bg-white shadow-[3px_3px_0px_#1A1A1A]"
      }`}
      data-testid={testid}
    >
      <div className={`flex items-center gap-1.5 mb-1 ${accent ? "text-[#EB5E28]" : "text-[#6B6A68]"}`}>
        {icon}
        <span className="font-sans-ui text-[10px] uppercase tracking-[0.2em] font-semibold">
          {label}
        </span>
      </div>
      <div className="font-serif-display text-3xl font-semibold tabular-nums">
        {value}
      </div>
    </div>
  );
}
